import React from 'react';
import { TouchableOpacity, View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

import { MY_DAY_STEP_STATUS } from '../../../../common/utils/myDay/driverDaySteps';
import { Label, Text } from '../../../components';
import { useThemedStyles } from '../../../hooks/useThemedStyles';
import { useTheme } from '../../../theme';

const STEP_STATUS_LABELS = {
	[MY_DAY_STEP_STATUS.DONE]: { label: 'Done', props: { green: true } },
	[MY_DAY_STEP_STATUS.TODO]: { label: 'To do', props: { primary: true } },
	[MY_DAY_STEP_STATUS.BLOCKED]: { label: 'Locked', props: { grey: true } },
	[MY_DAY_STEP_STATUS.INFO]: { label: 'Info', props: { secondary: true } },
};

const StepRow = ({
	step,
	onPress,
	expandedContent,
	active,
}) => {
	const styles = useThemedStyles(createStyles);
	const { theme } = useTheme();

	if (!step || step.status === MY_DAY_STEP_STATUS.HIDDEN) {
		return null;
	}

	const isBlocked = step.status === MY_DAY_STEP_STATUS.BLOCKED;
	const statusLabel = STEP_STATUS_LABELS[step.status];
	const isPressable = Boolean(onPress) && !isBlocked;

	return (
		<View style={styles.rowWrap}>
			<TouchableOpacity
				style={[styles.row, isBlocked && styles.rowBlocked, active && styles.rowActive]}
				activeOpacity={0.86}
				disabled={!isPressable}
				onPress={onPress}
			>
				<View style={styles.rowTextWrap}>
					<View style={styles.rowTitleLine}>
						<Text style={styles.rowTitle}>{step.label}</Text>
						{
							Boolean(step.badgeCount) && (
								<Label label={String(step.badgeCount)} primary={true} style={styles.badge} />
							)
						}
					</View>
					{
						Boolean(step.description) && (
							<Text style={styles.rowDescription}>{step.description}</Text>
						)
					}
				</View>
				<View style={styles.rowRight}>
					{
						statusLabel && (
							<Label label={statusLabel.label} {...statusLabel.props} style={styles.statusLabel} />
						)
					}
					{
						isPressable && (
							<Ionicons name="chevron-forward" size={16} color={theme.text2} />
						)
					}
					{
						isBlocked && (
							<Ionicons name="lock-closed-outline" size={16} color={theme.text2} />
						)
					}
				</View>
			</TouchableOpacity>
			{expandedContent || null}
		</View>
	);
};

const createStyles = (theme) => ({
	rowWrap: {
		marginBottom: 6,
	},
	row: {
		flexDirection: 'row',
		alignItems: 'center',
		backgroundColor: theme.mainBg3,
		borderRadius: 8,
		paddingVertical: 10,
		paddingHorizontal: 10,
	},
	rowBlocked: {
		opacity: 0.55,
	},
	rowActive: {
		borderWidth: 1,
		borderColor: theme.text1,
	},
	rowTextWrap: {
		flex: 1,
		paddingRight: 8,
	},
	rowTitleLine: {
		flexDirection: 'row',
		alignItems: 'center',
	},
	rowTitle: {
		fontSize: 14,
		fontWeight: '600',
		color: theme.text1,
	},
	badge: {
		marginLeft: 6,
		marginBottom: 0,
	},
	rowDescription: {
		marginTop: 2,
		fontSize: 12,
		color: theme.text2,
	},
	rowRight: {
		flexDirection: 'row',
		alignItems: 'center',
	},
	statusLabel: {
		marginRight: 6,
		marginBottom: 0,
	},
});

export default StepRow;
